<template>
  <div class="history-list">
    <ImageViewer :list="[showUrl]" :visible.sync="imageVisible" />
    <ZuEmpty v-if="!len" />
    <div class="history-item" v-for="(item, idx) in list" :key="item.id">
      <div class="history-item-l">
        <div class="index">{{ len - idx }}</div>
        <div class="date">{{ item.follow_time }}</div>
      </div>
      <div class="history-item-r">
        <div class="history-item-t">
          <div class="flex">
            <div class="btn btn-1">{{ item.will }}</div>
            <div class="btn btn-2">{{ item.status }}</div>
          </div>
          <div v-if="item.follow_proof" class="show-btn" @click="showImg(item.follow_proof)">查看跟进凭证</div>
        </div>
        <div class="history-item-p">
          <span class="label">跟进记录</span>
          <span class="value">{{ item.follow_remark }}</span>
        </div>
        <div class="flex">
          <div class="history-item-p flex-2">
            <span class="label">跟进方式</span>
            <span class="value">{{ item.method }}</span>
          </div>
          <div v-if="item.next_time" class="history-item-p flex-4">
            <span class="label">下次联系时间</span>
            <span class="value">{{ item.next_time }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="history-item-p flex-2">
            <span class="label">操作人</span>
            <span class="value">{{ item.creator_name }}</span>
          </div>
          <div class="history-item-p flex-4">
            <span class="label">操作时间</span>
            <span class="value">{{ item.updated_at }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageViewer from '@/components/common/ImageViewer'
import ZuEmpty from '@/components/common/ZuEmpty'
export default {
  props: {
    list: { type: Array, default: () => [] },
  },
  components: { ImageViewer, ZuEmpty },
  computed: {
    len() {
      return this.list.length
    }
  },
  data() {
    return {
      imageVisible: false,
      showUrl: '',
    }
  },
  methods: {
    showImg(url) {
      this.showUrl = url
      this.imageVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.history-list {
  background-color: #fff;
  &-box {
    flex: 1;
    overflow-y: auto;
  }
}
.history-item {
  padding-bottom: 20rem;
  display: flex;
  &:last-child {
    padding-bottom: 0;
  }
  &-l {
    position: relative;
    width: 70rem;
    margin-right: 20rem;
    flex-shrink: 0;
    text-align: center;
    &::before {
      content: '';
      position: absolute;
      left: 50%;
      top: 65rem;
      bottom: -5rem;
      width: 0;
      border-left: dashed 1rem #D8D8D8;
    }
    .index {
      width: 28rem;
      height: 28rem;
      margin: 0 auto;
      padding-top: 4rem;
      background-color: #E3F1FF;
      border-radius: 50%;
      font-size: 20rem;
      color: #417FF7;
      line-height: 20rem;
    }
    .date {
      margin-top: 8rem;
      font-size: 11rem;
      color: #3C3C3C;
      line-height: 16rem;
    }
  }
  &-r {
    flex: 1;
    padding: 14rem;
    background-color: #F9F9F9;
    border-radius: 8rem;
    display: flex;
    flex-direction: column;
    gap: 10rem;
    .title {
      font-size: 20rem;
      color: #333;
      line-height: 30rem;
      margin-bottom: 8rem;
    }
    .content {
      font-size: 16rem;
      color: #666;
      line-height: 24rem;
    }
  }
  &-t {
    display: flex;
    justify-content: space-between;
    .btn {
      padding: 0 10rem;
      margin-right: 20rem;
      line-height: 18rem;
      font-size: 14rem;
      border-radius: 2rem;
      &-1 {
        color: #fff;
        background-color: #507AFD;
      }
      &-2 {
        color: #507AFD;
        background-color: #EAEFFF;
        border: solid 1rem #507AFD;
        box-sizing: border-box;
      }
    }
    .show-btn {
      color: #507AFD;
      font-size: 11rem;
      line-height: 18rem;
      cursor: pointer;
    }
  }
  &-p {
    font-size: 13rem;
    display: flex;
    .label {
      width: 90rem;
      color: #888;
      line-height: 24rem;
    }
    .value {
      flex: 1;
      color: #3C3C3C;
      line-height: 24rem;
    }
  }
}
</style>
